import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";
import { User } from "~/common/Store/connectUserAndChat";
import { CarouselItem } from "~/ProductDetails/Carousel/CarouselItem";

export type ProductRecommendationsResult = {
  recAiCarouselItems: CarouselItem[];
  eventLabel: string;
};

const fetchProductRecommendationsCarouselItems = async (
  user: Pick<User, "registered" | "emailAddress" | "sessionId">,
  recAiPage?: number,
): Promise<Throwable<ProductRecommendationsResult>> => {
  try {
    const requestBody = user.registered
      ? JSON.stringify({
          userEmail: user.emailAddress,
          recAiPage,
        })
      : JSON.stringify({
          sessionId: user.sessionId,
        });

    const requestUrl = user.registered
      ? "/api/productrecommendationsforauser"
      : "/api/productrecommendations";

    const response = await fetch(requestUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: requestBody,
    });

    const result: {
      items: CarouselItem[];
      eventLabel: string;
    } = await response.json();

    return {
      isError: false,
      value: {
        recAiCarouselItems: result.items,
        eventLabel: result.eventLabel,
      },
    };
  } catch (error) {
    return {
      isError: true,
      error: toError(error),
    };
  }
};

export default fetchProductRecommendationsCarouselItems;
